import { IApplicationState } from '../../types/redux';

export function getAeroPhotoTourBackground(state: IApplicationState) {
  return state.aeroPhotoTour.backgroundImage;
}
